import React, { useEffect, useId, useRef, useState } from "react";
import Header from "../../components/layout/header";
import Footer from "../../components/layout/footer";
import img1 from "../../images/Group 28.png";
import { IoStar } from "react-icons/io5";
import { FiMinus, FiPlus } from "react-icons/fi";
import "./CartPage.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../constant";
import { toast } from "react-toastify";
import { useCartContext } from "../../Context/CartContext";
import { useWishlistContext } from "../../Context/WishlistContext";
import SliderHome from "../../components/SacredOfferingsSlider/SliderHome";
import { message } from "antd";
import DealOfTheDay from "../Home/DealOfTheDay";
import deal_icon from "../../images/Lightning Deal.svg";
import ShareModal from "./CopyLinkModal.js";
import FlashSale from "../Flash Sale/FlashSale";

const CartPage = ({ selectedPack }) => {
  const guestId = localStorage.getItem("guestId");
  const userId = localStorage.getItem("userId");

  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const stars = Array.from({ length: 5 });
  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const { fetchCartCount } = useCartContext();
  const [couponCode, setCouponCode] = useState("");
  const [appliedCode, setAppliedCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [validCoupons, setValidCoupons] = useState();
  const { fetchWishlistCount } = useWishlistContext();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [shareLink, setShareLink] = useState("");

  useEffect(() => {
    fetchCartItems();
    fetchWishlistCount();
  }, []);

  useEffect(() => {
    fetchCoupons();
  }, []);

  useEffect(() => {
    setTotal(subtotal - discount);
  }, [subtotal, discount]);

  const relatedProductsRef = useRef(null);

  const fetchCoupons = async () => {
    try {
      const userId = localStorage.getItem("userId");
      if (userId || guestId) {
        const response = await axios.get(`${BASE_URL}/api/coupons`);
        setValidCoupons(response.data);
      }
    } catch (error) {
      console.error("Error fetching Coupon codes:", error);
    }
  };

  const fetchCartItems = async () => {
    try {
      const userId = localStorage.getItem("userId");
      if (userId || guestId) {
        const response = await axios.post(
          `${BASE_URL}/usercart/in-cart?userId=${
            userId || guestId
          }&pageSize=10000`
        );
        setCartItems(response.data);
        console.log(response.data);
        // Calculate subtotal
        let total = 0;
        response.data.forEach((item) => {
          total += item.productRate * item.orderQuantity;
        });
        setSubtotal(total);
        setDeliveryCharge(response.data.length > 0 ? 100 : 0);
      }
    } catch (error) {
      console.error("Error fetching cart items:", error);
    }
  };

  const handleProductRemove = async (productId, showNotification = true) => {
    const userId = localStorage.getItem("userId");
    try {
      const response = await axios.post(
        `${BASE_URL}/usercart/remove-product?userId=${
          userId || guestId
        }&productId=${productId}`
      );
      await fetchCartCount();

      if (showNotification) {
        toast.error("Product removed from cart");
      }

      // If deletion is successful, fetch the updated cart items
      fetchCartItems();
      setCouponCode(null);
      setAppliedCode(null);
      setDiscount(0);
    } catch (error) {
      console.error("Error removing product from cart:", error);
      toast.error("Something went wrong! Try again later");
    }
  };

  const handleQuantityChange = async (productId, newQuantity) => {
    const userId = localStorage.getItem("userId");
    try {
      const response = await axios.post(
        `${BASE_URL}/usercart/update-quantity?userId=${
          userId || guestId
        }&productId=${productId}&orderQuantity=${newQuantity}`
      );

      // If quantity update is successful, fetch the updated cart items
      fetchCartItems();
    } catch (error) {
      console.error("Error updating quantity:", error);
      toast.error("Something went wrong! Try again later");
    }
  };

  const handleAddToWishlist = async (productId) => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      try {
        const wishlistResponse = await fetch(
          `${BASE_URL}/wishlist/add/${userId}`,

          {
            method: "POST",
            headers: {
              contentType: "application/json",
            },
            body: productId,
          }
        );
        await handleProductRemove(productId, false);
        fetchWishlistCount();
        console.log(productId);

        console.log(wishlistResponse.data);

        toast.success("Product added to wishlist");
      } catch (error) {
        console.error("Error adding product to wishlist:", error);
        toast.error("Something went wrong! Try again later");
      }
    } else {
      navigate("/login");
    }
  };

  const scrollToRelatedProducts = () => {
    relatedProductsRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  // const handleShare = (productId) => {
  //   if (navigator.clipboard && navigator.clipboard.writeText) {
  //     console.log("going");
  //     const itemUrl = `${window.location.origin}/productdetails/${productId}`;
  //     navigator.clipboard.writeText(itemUrl);
  //     toast.success("Product link copied");
  //   }
  // };

  const applyCoupon = () => {
    const userId = localStorage.getItem("userId");

    if (cartItems.length === 0) {
      message.warning("Add items to your cart before applying a coupon code.");
      return;
    }

    const matchingCoupon = validCoupons?.find(
      (coupon) =>
        coupon.couponName === couponCode && coupon.couponStatus === "active"
    );

    if (matchingCoupon) {
      console.log(matchingCoupon);
      if (matchingCoupon.is_product_copoun) {
        const productInCart = cartItems.some(
          (item) => item.productId === matchingCoupon.productId
        );

        if (productInCart) {
          // Apply the coupon if the product is in the cart
          if (matchingCoupon.couponType === "%") {
            setDiscount((subtotal / 100) * matchingCoupon.couponValue);
            setAppliedCode(matchingCoupon.couponName);
            toast.success(
              `Coupon applied! You get a ${matchingCoupon.couponValue}% discount on the subtotal.`
            );
          } else if (matchingCoupon.couponType === "Rs") {
            setDiscount(parseFloat(matchingCoupon.couponValue));
            setAppliedCode(matchingCoupon.couponName);
            toast.success(
              `Coupon applied! You get a ₹${matchingCoupon.couponValue} discount on the subtotal.`
            );
          }
        } else {
          // Product not found in the cart
          toast.error(
            "No matching product found in your cart for this coupon."
          );
        }
      } else {
        // General coupon, apply it to the entire cart
        if (matchingCoupon.couponType === "%") {
          setDiscount((subtotal / 100) * matchingCoupon.couponValue);
          setAppliedCode(matchingCoupon.couponName);
          toast.success(
            `Coupon applied! You get a ${matchingCoupon.couponValue}% discount on the subtotal.`
          );
        } else if (matchingCoupon.couponType === "Rs") {
          setDiscount(parseFloat(matchingCoupon.couponValue));
          setAppliedCode(matchingCoupon.couponName);
          toast.success(
            `Coupon applied! You get a ₹${matchingCoupon.couponValue} discount on the subtotal.`
          );
        }
      }
    } else {
      setDiscount(0);
      toast.error("Invalid or inactive coupon code.");
    }
  };

  const openShareModal = (productId) => {
    const baseUrl = `${window.location.origin}`;
    const productDetailsUrl = `${baseUrl}/productdetails/${productId}`;
    setShareLink(productDetailsUrl);
    setModalIsOpen(true);
  };

  const closeShareModal = () => {
    setModalIsOpen(false);
  };

  const handleCopyLink = () => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(shareLink)
        .then(() => {
          toast.success("Product link copied");
        })
        .catch((error) => {
          console.error("Error copying text: ", error);
          toast.error("Failed to copy product link");
        });
    } else {
      // Fallback method
      const textarea = document.createElement("textarea");
      textarea.value = shareLink;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        toast.success("Product link copied");
      } catch (error) {
        console.error("Fallback copy failed: ", error);
        toast.error("Failed to copy product link");
      }
      document.body.removeChild(textarea);
    }
  };
  console.log(cartItems);
  return (
    <div className="cart-container">
      <Header />
      <div className="cart-products-container">
        {cartItems.length > 0 ? <h4>Your Cart</h4> : ""}
        {cartItems.length > 0 ? (
          cartItems.map((item) => {
            return (
              <React.Fragment>
                <div key={item.productId} className="cart-product">
                  <div className="image-conatiner">
                    <img
                      src={
                        item.productImage
                          ? item.productImage
                          : "https://balache-kapde-media.s3.ap-south-1.amazonaws.com/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg"
                      }
                      alt={item.productName}
                      loading="lazy"
                      onClick={() => navigate("/cart")}
                    />
                  </div>
                  <div className="cart-desc">
                    <div className="cart-row">
                      <div className="product-header-div">
                        <h5>{item.productName}</h5>
                        <div>
                          {item.lightning ? (
                            <div className="deal-icon-container">
                              <img alt="" src={deal_icon} />
                              <div className="text-overlay">Lighting Deal</div>
                            </div>
                          ) : null}
                          {item.offered ? (
                            <div
                              style={{
                                color: "red",
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                fontSize: 23,
                              }}
                            >
                              OFFER
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="cart-product-price">
                        <div className="cart-product-rating">
                          <div>
                            {stars.map((_, index) => (
                              <IoStar key={index} className="cart-stars" />
                            ))}
                          </div>
                          <p>₹ {item.productRate}</p>
                        </div>
                      </div>
                    </div>
                    <div className="cart-buttons">
                      <div>
                        <p>Color: {item.productColor}</p>
                        <p>Size: {item.productSize}</p>
                      </div>
                      <div className="cart-quantity-container">
                        <p>Quantity</p>
                        <div className="cart-quantity-btn cart-page-cart-quantity-btn ">
                          <button
                            type="button"
                            disabled={item.orderQuantity == 1}
                            onClick={() =>
                              handleQuantityChange(
                                item.productId,
                                parseInt(item.orderQuantity, 10) - 1
                              )
                            }
                          >
                            <FiMinus />
                          </button>
                          {item.orderQuantity}
                          <button
                            type="button"
                            onClick={() => {
                              if (
                                parseInt(item.orderQuantity, 10) <
                                item.stockQuantity
                              ) {
                                handleQuantityChange(
                                  item.productId,
                                  parseInt(item.orderQuantity, 10) + 1
                                );
                              } else {
                                toast.warn(
                                  "Currently, Few products are Out of Stock!",
                                  {
                                    position: "top-center",
                                  }
                                );
                              }
                            }}
                            disabled={
                              parseInt(item.orderQuantity, 10) >=
                              item.stockQuantity
                            }
                          >
                            <FiPlus />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="options">
                      <span
                        onClick={() =>
                          handleProductRemove(item.productId, true)
                        }
                      >
                        Delete
                      </span>
                      <span onClick={() => handleAddToWishlist(item.productId)}>
                        Save for later
                      </span>
                      <span onClick={scrollToRelatedProducts}>
                        See more like this
                      </span>
                      <span
                        // onClick={() => handleShare(item.productid)}
                        onClick={() => openShareModal(item.productId)}
                      >
                        Share
                      </span>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            );
          })
        ) : (
          <div className="cart-products-container">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                padding: "50px 0",
              }}
            >
              <img
                src={
                  "https://images.vexels.com/media/users/3/132103/isolated/preview/2b512b5ece5d914e68950bfdbf73b481-shopping-cart-circle-icon-by-vexels.png"
                }
                width={"200px"}
              />
              <h3 style={{ fontSize: "30px" }}>Your Cart is Empty!</h3>
              <p
                style={{
                  fontSize: "20px",
                  textAlign: "center",
                  marginBottom: "20px",
                }}
              >
                Must add items before you proceed to checkout.
              </p>
              <button
                className="empty-cart-btn"
                type="submit"
                onClick={() => navigate("/shop")}
              >
                Add Products
              </button>
            </div>
          </div>
        )}
      </div>
      {userId || guestId ? (
        <React.Fragment>
          <div
            className="coupon-card-continer d-flex align-items-center justify-content-center gap-3 mt-4 "
            style={{ margin: "0px 50px" }}
          >
            <div className="coupon-card">
              <h1
                style={{
                  fontSize: "25px",
                  fontWeight: "bold",
                  marginBottom: "20px",
                }}
              >
                Coupon Code
              </h1>
              <div className="d-flex flex-column align-items-center justify-content-center gap-4">
                <input
                  type="text"
                  placeholder="Apply coupon code here"
                  value={couponCode}
                  onChange={(e) => setCouponCode(e.target.value)}
                />
                <button
                  style={{
                    background: "#FFC55B",
                    color: "#000",
                    border: "none",
                    padding: "15px 30px",
                    borderRadius: "50px",
                    fontWeight: "bold",
                    width: "100%",
                    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                  }}
                  type="button"
                  onClick={applyCoupon}
                >
                  Apply
                </button>
              </div>
            </div>
            <div className="coupon-card" id="total-price-card">
              <div className="d-flex flex-column align-items-center justify-content-center">
                <table className="coupon-table">
                  <tr>
                    <td>Subtotal</td>
                    <td>Rs {subtotal.toFixed(2)}</td>
                  </tr>
                  {/* <tr>
                    <td>Shipping</td>
                    <td>Shipping Charges as Applicable will be informed after Order Confirmation</td>
                  </tr> */}
                  <tr>
                    <td>Discount</td>
                    <td>Rs {discount.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td>Total</td>
                    <td>Rs {total.toFixed(2)}</td>
                  </tr>
                </table>
                <p
                  style={{
                    marginTop: "0px",
                    color: "#0b9931",
                    fontStyle: "italic",
                  }}
                >
                  Shipping Charges as Applicable will be informed after Order
                  Confirmation.
                </p>

                <button
                  type="submit"
                  onClick={() => {
                    const userId = localStorage.getItem("userId");
                    if (
                      (userId && cartItems.length > 0) ||
                      (guestId && cartItems.length > 0)
                    ) {
                      navigate("/checkout", { state: { appliedCode } });
                    } else {
                      message.warning(
                        "Add Items in cart before proceed to checkout"
                      );
                    }
                  }}
                  style={{
                    background: "#FFC55B",
                    color: "#000",
                    border: "none",
                    fontWeight: "bold",
                    padding: "15px 30px",
                    borderRadius: "50px",
                    width: "100%",
                    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                  }}
                >
                  Proceed to Buy
                </button>
              </div>
            </div>
          </div>
          <div ref={relatedProductsRef}>
            <DealOfTheDay title={" Related Products "} />
          </div>
        </React.Fragment>
      ) : (
        ""
      )}

      {/* Modal for sharing */}
      <ShareModal
        show={modalIsOpen}
        handleClose={closeShareModal}
        shareLink={shareLink}
        handleCopyLink={handleCopyLink}
      />
      <Footer />
    </div>
  );
};

export default CartPage;
